import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import get from 'lodash/get';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { ACCOUNT_ID, DP_USER_STATE } from '../common/Constants';
import constants from './CreateAccountConfig';

export class createAccountActionFilter extends BaseActionFilter {
    getCreateAccountPageDL(store, data) {
        const { context } = store.getState();
        let deviceType = '';
        if (context.deviceType.isMobile) {
            deviceType = 'mobile';
        } else if (context.deviceType.isDesktop) {
            deviceType = 'desktop';
        } else {
            deviceType = 'tablet';
        }

        /* istanbul ignore next */
        let profileID = TokenProvider.get(ACCOUNT_ID) || '';
        const isGuest = TokenProvider.get(DP_USER_STATE);
        /* istanbul ignore next */
        if (isGuest === '0') {
            profileID = '';
        }
        /* istanbul ignore next */
        const rewardTier = TokenProvider.get('DP_REWARDS_TIER') || '';
        /* istanbul ignore next */
        const searchRedirect = this.getURLParameterBykey('redirectTerm') || '';

        const createAccPageDL = this.updateCommonDigitalData();
        /* istanbul ignore next */
        let associateFlag = createAccPageDL.user.profile.profileInfo.associateFlag || 'no';
        createAccPageDL.page.pageInfo.pageName = data.pageName.toLowerCase();
        createAccPageDL.page.pageInfo.pageType = 'account';
        createAccPageDL.page.pageInfo.siteSection = 'account';
        createAccPageDL.page.pageInfo.deviceType = deviceType;
        createAccPageDL.page.pageInfo.searchRedirect = searchRedirect;
        createAccPageDL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        createAccPageDL.page.pageInfo.version = get(
            data,
            'version',
            'apollo 1 2017 redesign yoda account'
        ); // TODO when we have multiple template
        createAccPageDL.page.pageInfo.clusterInstance = Cookies.load('DPInstance');
        createAccPageDL.page.category = {};
        createAccPageDL.page.category.primaryCategory = constants.siteSection.HOME;
        createAccPageDL.page.category.subCategory1 = '';
        createAccPageDL.page.category.subCategory2 = '';
        createAccPageDL.page.category.department = constants.siteSection.HOME;
        createAccPageDL.user.profile.profileInfo.profileID = profileID;
        createAccPageDL.user.profile.profileInfo.rewardsMemberType = rewardTier; // silver gold platinum bronze red pending
        createAccPageDL.user.profile.profileInfo.expressCheckoutEnabled = ''; // yes or no
        createAccPageDL.user.profile.profileInfo.mobileOptIn = []; // transactional promotional promotional transactional  no selection  no
        /* istanbul ignore next */
        if (!profileID) {
            associateFlag = '';
            createAccPageDL.user.profile.profileInfo.profileType = [];
            createAccPageDL.user.profile.profileInfo.emailOptIn = ''; // "yes or no"
        }

        createAccPageDL.user.profile.profileInfo.associateFlag = associateFlag; // yes or no
        /* istanbul ignore next */
        createAccPageDL.user.profile.profileInfo.storeID = '';
        createAccPageDL.error = [];
        createAccPageDL.error.push({
            errorDescription: '',
        });
        return createAccPageDL;
    }

    getGroupAPL(store) {
        const { context } = store.getState();

        let deviceType = '';
        if (context.deviceType.isMobile) {
            deviceType = 'mobile';
        } else if (context.deviceType.isDesktop) {
            deviceType = 'desktop';
        } else {
            deviceType = 'tablet';
        }

        /* istanbul ignore next */
        const rewardTier = TokenProvider.get('DP_REWARDS_TIER') || '';

        const profileID = TokenProvider.get(ACCOUNT_ID);
        /* istanbul ignore next */
        const searchRedirect = this.getURLParameterBykey('redirectTerm') || '';

        const getGroupADL = this.updateCommonDigitalData();
        /* istanbul ignore next */
        const associateFlag = getGroupADL.user.profile.profileInfo.associateFlag || 'no';
        getGroupADL.page.pageInfo.pageName = 'create account group-a';
        getGroupADL.page.pageInfo.pageType = 'rewards';
        getGroupADL.page.pageInfo.siteSection = 'rewards';
        getGroupADL.page.pageInfo.deviceType = deviceType;
        getGroupADL.page.pageInfo.searchRedirect = searchRedirect;
        getGroupADL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        getGroupADL.page.pageInfo.version = 'apollo 1 2017 redesign yoda account'; // TODO when we have multiple template
        getGroupADL.page.pageInfo.clusterInstance = Cookies.load('DPInstance');
        getGroupADL.page.category = {};
        getGroupADL.page.category.primaryCategory = 'account';
        getGroupADL.page.category.subCategory1 = '';
        getGroupADL.page.category.subCategory2 = '';
        getGroupADL.page.category.department = 'account';
        getGroupADL.user.profile.profileInfo.profileID = profileID;
        getGroupADL.user.profile.profileInfo.rewardsMemberType = rewardTier; // silver gold platinum bronze red pending
        getGroupADL.user.profile.profileInfo.expressCheckoutEnabled = ''; // yes or no
        getGroupADL.user.profile.profileInfo.associateFlag = associateFlag; // yes or no
        getGroupADL.error = [];
        getGroupADL.error.push({
            errorDescription: '',
        });

        return getGroupADL;
    }

    getCreateAccountFormErrorPL(error) {
        let createAccountFormErrorDL = this.updateCommonDigitalData();
        createAccountFormErrorDL = {
            error,
        };
        return createAccountFormErrorDL;
    }

    getAccountRegisteredPL() {
        const getCreateAccPageDL = this.updateCommonDigitalData();
        /* istanbul ignore next */
        const associateFlag = getCreateAccPageDL.user.profile.profileInfo.associateFlag || 'no';
        const getCreateAccountRegisteredDL = {
            user: getCreateAccPageDL.user,
        };
        /* istanbul ignore else */
        if (getCreateAccPageDL.user.profile.profileInfo.mobileOptIn.length === 0) {
            getCreateAccPageDL.user.profile.profileInfo.mobileOptIn.push('no selection');
        }
        /* istanbul ignore else */
        if (!getCreateAccountRegisteredDL.user.profile.profileInfo.emailOptIn) {
            getCreateAccountRegisteredDL.user.profile.profileInfo.emailOptIn = 'yes';
        }
        /* istanbul ignore next */
        const rewardTier =
            TokenProvider.get('DP_REWARDS_TIER') ||
            getCreateAccountRegisteredDL.user.profile.profileInfo.rewardsMemberType ||
            'base';
        getCreateAccountRegisteredDL.user.profile.profileInfo.rewardsMemberType = rewardTier; // silver gold platinum bronze red pending
        getCreateAccountRegisteredDL.user.profile.profileInfo.rewardsFlag = 'yes';
        getCreateAccountRegisteredDL.user.profile.profileInfo.associateFlag = associateFlag; // yes or no
        delete getCreateAccountRegisteredDL.user.profile.profileInfo.storeID;
        delete getCreateAccountRegisteredDL.user.profile.profileInfo.itemsInSaveForLater;

        return getCreateAccountRegisteredDL;
    }

    getSignoutPageDL(store, data) {
        const { context } = store.getState();
        let deviceType = '';
        if (context.deviceType.isMobile) {
            deviceType = 'mobile';
        } else if (context.deviceType.isDesktop) {
            deviceType = 'desktop';
        } else {
            deviceType = 'tablet';
        }
        /* istanbul ignore next */
        const searchRedirect = this.getURLParameterBykey('redirectTerm') || '';

        const signoutPageDL = this.updateCommonDigitalData();
        signoutPageDL.page.pageInfo.pageName = data.pageName.toLowerCase();
        signoutPageDL.page.pageInfo.pageType = 'account';
        signoutPageDL.page.pageInfo.siteSection = 'account';
        signoutPageDL.page.pageInfo.deviceType = deviceType;
        signoutPageDL.page.pageInfo.searchRedirect = searchRedirect;
        signoutPageDL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        signoutPageDL.page.pageInfo.version = 'apollo 1 2017 redesign yoda account'; // TODO when we have multiple template
        signoutPageDL.page.pageInfo.clusterInstance = Cookies.load('DPInstance');
        signoutPageDL.page.category = {};
        signoutPageDL.page.category.primaryCategory = 'account';
        signoutPageDL.page.category.subCategory1 = '';
        signoutPageDL.page.category.subCategory2 = '';
        signoutPageDL.page.category.department = 'account';
        signoutPageDL.user.profile.profileInfo.profileID = '';
        signoutPageDL.user.profile.profileInfo.rewardsMemberType = ''; // silver gold platinum bronze red pending
        signoutPageDL.user.profile.profileInfo.expressCheckoutEnabled = ''; // yes or no
        signoutPageDL.user.profile.profileInfo.mobileOptIn = []; // transactional promotional promotional transactional  no selection  no
        signoutPageDL.user.profile.profileInfo.profileType = [];
        signoutPageDL.user.profile.profileInfo.emailOptIn = ''; // "yes or no"
        signoutPageDL.user.profile.profileInfo.associateFlag = ''; // yes or no
        signoutPageDL.error = [];
        signoutPageDL.error.push({
            errorDescription: '',
        });
        return signoutPageDL;
    }
}

export default createAccountActionFilter;
